import React, { useState } from 'react';
import { X, Zap } from 'lucide-react';

const UrgencyBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem('urgency_dismissed') === 'true';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem('urgency_dismissed', 'true');
    } catch {}
  };

  return (
    <div
      className="relative flex items-center justify-center gap-2 px-4 py-2.5 text-white text-sm font-medium"
      style={{
        background: 'linear-gradient(90deg, hsl(350,70%,55%) 0%, hsl(20,90%,60%) 50%, hsl(350,70%,55%) 100%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 3s linear infinite',
      }}
    >
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% center; }
          100% { background-position: -200% center; }
        }
      `}</style>
      <Zap className="w-3.5 h-3.5 flex-shrink-0 fill-yellow-300 text-yellow-300" />
      <span className="text-center">
        🎉 <strong>Limited Launch Offer</strong> — First 50 customers get an exclusive discount!
        <span className="hidden sm:inline"> Use code <strong>AURA15</strong> when ordering.</span>
      </span>
      <button
        onClick={handleDismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/20 transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default UrgencyBanner;
